import { FormGroup, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { Directive, forwardRef, Input } from '@angular/core';

@Directive({
  selector: '[capEgridValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => EgridValidatorDirective), multi: true }]
})
export class EgridValidatorDirective implements Validator {
  @Input() doValidate = false;

  validate(control: FormGroup): ValidationErrors {
    if (this.doValidate) {
      const egrid = control.controls['egrid.value'];
      const grundbuchgeschaeft = control.get('grundbuchamtId');
      const beteiligteGrundstuecke = control.get('grundstueckNummer');
      if (grundbuchgeschaeft && beteiligteGrundstuecke && egrid) {
        const grundbuchgeschaeftNoError = grundbuchgeschaeft && grundbuchgeschaeft.errors == null;
        const beteiligteGrundstueckeNoError = beteiligteGrundstuecke && beteiligteGrundstuecke.errors == null;

        const egridNotNull = egrid && egrid.value != null;
        const egridNull = egrid && egrid.value == null;
        const egridNotEmpty = egrid && egrid.value !== '';
        const egridEmpty = egrid && egrid.value === '';

        if (
          (grundbuchgeschaeft.valid || beteiligteGrundstuecke.valid || egrid.valid) &&
          (egridNull || egridEmpty || (egridNotNull && egridNotEmpty) || grundbuchgeschaeftNoError || beteiligteGrundstueckeNoError) &&
          ((beteiligteGrundstuecke.value &&
            beteiligteGrundstuecke.value.gbGemeindeId !== '' &&
            beteiligteGrundstuecke.value.gbGemeindeId !== null) ||
            (grundbuchgeschaeft.value &&
              grundbuchgeschaeft.value.grundbuchamtId !== '' &&
              grundbuchgeschaeft.value.grundbuchamtId !== null) ||
            (egridNotNull && egridNotEmpty))
        ) {
          return null;
        } else {
          return { minimumEingabe: true };
        }
      }
    } else {
      return null;
    }
  }
}
